export class PaymentReq {
    soId:number
    collection:number
}
export class PaymentTypeReq {
    tab:string;
    buyer?:number;
    advance?:boolean
    financeYear?:string;
    unitId?:string

    constructor(
        tab:string,
    buyer?:number,
    advance?:boolean,
    financeYear?:string,
    unitId?:string

    
    ){
        this.buyer = buyer
        this.tab = tab
        this.advance = advance
        this.financeYear = financeYear
        this.unitId = unitId
    }
}


export class CollectionsFilters {

    buyer?:string
    invNo?: string;
    unitId?:string

    constructor(
    buyer?:string,
    invNo?:string,
    unitId?:string

    ){
        this.buyer = buyer
        this.invNo = invNo
        this.unitId  = unitId
        
        
    }
}

export class AgingReq {
  fromDate?:string;
    toDate?:string;
    unitId?:number
    vendorId?:number
    constructor(
        fromDate?:string,
        toDate?:string,
        unitId?:number,
        vendorId?:number


    ){
        this.fromDate= fromDate
        this.toDate = toDate
        this.unitId = unitId
       
        
    }
}

export class RmInvoiceDataForPayablesReq {
    invoiceNumber?:string;
    constructor(
        invoiceNumber?:string
    ){
        this.invoiceNumber = invoiceNumber
    }
}

export class RmPayblesReq{
    rmType?:string;
}